export const applyPastelEffect = async (canvas, ctx, setMessage, language) => {
  // 파스텔 효과: 부드럽고 분말 같은 질감
  // 1. 색상 부드럽게 만들기
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  for (let i = 0; i < data.length; i += 4) {
    // 채도 감소 (파스텔의 부드러운 색감)
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = avg + (data[i] - avg) * 0.6;
    data[i + 1] = avg + (data[i + 1] - avg) * 0.6;
    data[i + 2] = avg + (data[i + 2] - avg) * 0.6;
    
    // 전체적으로 밝게 (파스텔의 밝은 톤)
    data[i] = Math.min(255, data[i] * 0.8 + 50);
    data[i + 1] = Math.min(255, data[i + 1] * 0.8 + 50);
    data[i + 2] = Math.min(255, data[i + 2] * 0.8 + 50);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 블러링으로 부드러운 효과
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const blurData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const blurPixels = blurData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  const blurRadius = 3;
  for (let y = blurRadius; y < canvas.height - blurRadius; y++) {
    for (let x = blurRadius; x < canvas.width - blurRadius; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        let count = 0;
        
        for (let dy = -blurRadius; dy <= blurRadius; dy++) {
          for (let dx = -blurRadius; dx <= blurRadius; dx++) {
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance <= blurRadius) {
              const weight = 1 - (distance / blurRadius);
              const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
              sum += tempData[neighborPos + c] * weight;
              count += weight;
            }
          }
        }
        
        blurPixels[pos + c] = sum / count;
      }
    }
  }
  
  ctx.putImageData(blurData, 0, 0);
  
  // 3. 파스텔 분말 질감 효과
  const textureData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const texturePixels = textureData.data;
  
  for (let i = 0; i < texturePixels.length; i += 4) {
    // 파스텔 분말의 거친 질감 시뮬레이션
    if (Math.random() > 0.93) {
      const powderEffect = (Math.random() - 0.5) * 35;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + powderEffect));
      }
    }
    
    // 종이 질감 효과
    const x = (i / 4) % canvas.width;
    const y = Math.floor((i / 4) / canvas.width);
    const paperTexture = Math.sin(x * 0.05) * Math.cos(y * 0.05) * 8;
    
    for (let c = 0; c < 3; c++) {
      texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + paperTexture));
    }
  }
  
  ctx.putImageData(textureData, 0, 0);
  
  // 4. 부드러운 그라데이션 효과
  const gradientData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const gradientPixels = gradientData.data;
  
  // 색상 경계를 더 부드럽게
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        const current = texturePixels[pos + c];
        const neighbors = [
          texturePixels[((y - 1) * canvas.width + x) * 4 + c],
          texturePixels[((y + 1) * canvas.width + x) * 4 + c],
          texturePixels[(y * canvas.width + (x - 1)) * 4 + c],
          texturePixels[(y * canvas.width + (x + 1)) * 4 + c]
        ];
        
        const avgNeighbor = neighbors.reduce((sum, val) => sum + val, 0) / neighbors.length;
        gradientPixels[pos + c] = current * 0.7 + avgNeighbor * 0.3;
      }
    }
  }
  
  ctx.putImageData(gradientData, 0, 0);
};